// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3qobW","itemTitle":"ClientEmergencyInfo_itemTitle__UdJZP","itemText":"ClientEmergencyInfo_itemText__-67O_"};